import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { AnchorComponent, ButtonComponent } from "../elements";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function MisGirasTableComponent({ thead, data }) {

    const { t } = useContext(TranslatorContext)

    const [alertModal, setAlertModal] = useState(false);
   
    const [giras, setGiras] = useState([]);

    useEffect(() => { setGiras(data) }, [data]);
   

    return (
        <div className="mc-table-responsive">
            <table className="mc-table product">
                <thead className="mc-table-head primary">
                    <tr>
                       
                        {thead?.map((item, index) => (
                            <th key={ index }>{ t(item) }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body">
                    {giras?.map((item, index) => (
                            <tr key={ index }> 
                                <td>{ item.alu_nombres } </td>
                                <td> { item.alu_apellidos }</td>
                                <td>{item.alu_rut.toLocaleString('es-CL')}-{item.alu_dv}</td>
                                <td>{ item.est_nombre } </td>
                                <td>{ item.gir_curso }</td>
                                <td>{ item.programa }</td>
                                <td> 
                                                                                                { item.informacion !== null && item.pagos === null && <p className="mc-table-badge green">No presenta problemas</p> }

                                                                                                { item.informacion === null && <OverlayTrigger placement="top" overlay={<Tooltip>Es necesario completar información del pasajero </Tooltip>}>
                                                                                                    <p className="mc-table-badge red">Completar información</p>
                                                                                                    </OverlayTrigger>  }
                                                                                                { item.pagos !== null && <OverlayTrigger placement="top" overlay={<Tooltip>Tienes pagos pendientes que deben ser realizados antes de la fecha límite </Tooltip>}>
                                                                                                <p className="mc-table-badge red" >Pagos pendientes</p>
                                                                                                 </OverlayTrigger> }</td>
                                                                                           
                                                                                            
                                                                                            <td>
                                                                                                <div className="mc-table-action">
                                                                                                    <AnchorComponent to={{
                                                                                                          pathname: "/ver-mi-gira",
                                                                                                          search: "?gira="+item.gir_id+"&alumno="+item.alu_id,
                                                                                                    }} title="View" className="material-icons view"><i className='material-icons'>search</i></AnchorComponent>
                                                                                                  
                                                                                                </div>
                                                                                            </td>
                            </tr>
                    ))}
                </tbody>
            </table>

            <Modal show={ alertModal } onHide={()=> setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>are your sure!</h3>
                    <p>Want to delete this product?</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setAlertModal(false)}>{t('close')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={()=> setAlertModal(false)}>{t('delete')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    );
}